module.exports = "https://static.wmbcdn.com/uniweb/images/e6bd20699ca67a3120231e5c7921b4b9.svg";